const styles = ({ FONT_SIZES, COLORS, BREAKPOINTS }) => ({
  head: {
    height: '70px',
    backgroundColor: '#fff',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)'
  },
  title: {
    margin: '0',
    padding: '0',
    fontWeight: 'normal',
    color: '#8a8a8a',
    ...FONT_SIZES.HEADING_LARGE.STYLE
  },
  paper: {
    maxWidth: '1280px',
    margin: '30px auto 60px'
  },
  tabContainer: {
    padding: '30px 0 0'
  },
  plus: {
    fontSize: '18px',
    fontWeight: 'normal',
    position: 'absolute',
    right: 0,
    '& svg': {
      marginRight: '4px'
    }
  },
  banner: {
    maxWidth: '1280px',
    margin: '30px auto 0',
    padding: '0 20px',
    '& a': {
      color: COLORS.BLUE.NORMAL
    }
  },
  hideMobile: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'none'
    }
  }
})

export default styles
